import React from 'react';
import services from 'services';
import { withRouter } from 'react-router-dom';
import imgPlaceholder from 'assets/images/imagePlaceholder.jpg';
import logoPlaceholder from 'assets/images/image-placeholder.jpg';
import Typography from 'microcomponents/typography';
import urls from 'configs/urls';

class CompanyProfile extends React.Component {
  state = {
    data: '',
    summeryData: '',
  };

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }
  componentDidMount() {
    this.loadDate();
    window.scrollTo(0, 0);
  }

  loadDate = async () => {
    const { match } = this.props;
    const id = match.params.id;
    const model = { Company_id: id };
    const data = await services.insurance.selectCompany(model);
    this.setState({
      data,
      summeryData: data.AboutInsuranceCompany.substring(0, 320),
    });
  };

  render() {
    const { data, summeryData } = this.state;
    return (
      <>
        <section className="companyprofile" ref={this.myRef}>
          <div className="container">
            <div className="header-companyprofile">
              <div className="image-back-companyprofile" id="imageCompany">
                <img
                  src={
                    data.InsuranceCompanyHeader === null
                      ? imgPlaceholder
                      : urls.imageUri + data.InsuranceCompanyHeader
                  }
                  alt={data.InsuranceCompanyName}
                />
              </div>
              <div className="color-back-companyprofile"></div>
              <div className="row justify-content-center align-items-end content-header-companyprofile">
                <div className="col-md-2 col-6">
                  <div
                    className="image-header-companyprofile"
                    id="logoInsurance"
                  >
                    <img
                      src={
                        data.InsuranceCompanyLogo === null
                          ? logoPlaceholder
                          : urls.imageUri + data.InsuranceCompanyLogo
                      }
                      alt={data.InsuranceCompanyName}
                    />
                  </div>
                </div>
                <div
                  className="col-md-10 col-12 text-header-companyprofile"
                  id="infoInsurance"
                >
                  <h3>{data.InsuranceCompanyName}</h3>
                  <span>{summeryData}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about-companyprofile">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row info-companyprofile"
                  id="infoCompanyProfile"
                >
                  <div className="col-md-2 col-6">
                    <div className="info-company-Insurance">
                      {data.phon_number === null ? '' : data.phon_number}
                      <p>شماره تلفن مرکز تماس</p>
                    </div>
                  </div>
                  <div className="col-md-2 col-6">
                    <div className="info-company-Insurance">
                      {data.shoab_pardakht_khesarat === null
                        ? ''
                        : data.shoab_pardakht_khesarat}
                      <p>شعب پرداخت سیار</p>
                    </div>
                  </div>
                  <div className="col-md-2 col-6">
                    <div className="info-company-Insurance">
                      {data.sale_tasis === null ? '' : data.sale_tasis}
                      <p>سال تاسیس</p>
                    </div>
                  </div>
                  <div className="col-md-2 col-6">
                    <div className="info-company-Insurance">
                      {data.tedad_karkonan === null ? '' : data.tedad_karkonan}
                      <p>تعداد کارکنان</p>
                    </div>
                  </div>
                  <div className="col-md-2 col-6">
                    <div className="info-company-Insurance">
                      {data.sahm_bazar === null ? '' : data.sahm_bazar}%
                      <p>سهم بازار</p>
                    </div>
                  </div>
                  <div className="col-md-2 col-6">
                    <div className="info-company-Insurance">
                      سطح{' '}
                      {data.sath_tavangari_mali === null
                        ? '0'
                        : data.sath_tavangari_mali}{' '}
                      از ۵<p>سطح توانگری مالی</p>
                    </div>
                  </div>
                  <div className="col-md-2 col-6">
                    <div className="info-company-Insurance">
                      {data.tedad_namayande === null
                        ? ''
                        : data.tedad_namayande}
                      <p>تعداد نماینده</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="content-companyprofile">
              <Typography paragraph>{data.AboutInsuranceCompany}</Typography>
            </div>
          </div>
        </section>

        <section className="footercompanyprofile">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="title-companyprofile">
                  <i className="icon-archive" />
                  <h1>
                    بیمه‌های ارائه شده توسط شرکت {data.InsuranceCompanyName}
                  </h1>
                </div>
              </div>
              <div className="col-md-12">
                <div className="row">
                  {data.servises === undefined
                    ? null
                    : data.servises.map((item, index) => (
                        <div className="col-md-2 col-4" key={index}>
                          <div className="iconFootercompanyprofile">
                            {item.name === 'بیمه‌ی شخص ثالث' ? (
                              <i className="icon-car" />
                            ) : item.name === 'بیمه بدنه' ? (
                              <i className="icon-car" />
                            ) : (
                              item.name === 'بیمه‌ی موتور' && (
                                <i className="icon-helmet" />
                              )
                            )}
                            <p>{item.name}</p>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default withRouter(CompanyProfile);
